import React, { useState, useEffect } from "react";
import "./styles/Footer.css";
import { Link } from "react-router-dom";

const APP_STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
const APP_BUY_BUTTON_ID = process.env.REACT_APP_BUY_BUTTON_ID;
const APP_URL_STRIPE = process.env.REACT_APP_URL_STRIPE;

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const URL_FORM_BREVO = process.env.REACT_APP_URL_FORM_BREVO;

  useEffect(() => {
    const script = document.createElement("script");
    script.src = APP_URL_STRIPE;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content container">
        {/* Section de don avec Stripe */}
        <div className="donation-section mt-5">
          <p>Your support helps us keep our content free and valuable!</p>
          <stripe-buy-button
            buy-button-id={APP_BUY_BUTTON_ID}
            publishable-key={APP_STRIPE_KEY}
          ></stripe-buy-button>

          {/* QR Code */}
          <div className="qr-code-section">
            <p>Or scan this QR code to donate:</p>
            <img
              src={require("../assets/qr_00g8ycc0q5GhaLm3cc.png")}
              alt="Donate QR Code"
              className="qr-code"
              style={{ height: 150 }}
            />
          </div>
        </div>
        <div className="social-links mt-4">
          <h5 className="pt-3" style={{ color: "#008cba" }}>
            Follow us
          </h5>
          <Link
            to="https://www.linkedin.com/company/weeklycyber/about/?viewAsMember=true"
            aria-label="Linkedin"
          >
            Linkedin
          </Link>
          {/* <Link to="#!" aria-label="Twitter">
            Twitter
          </Link> */}
          <Link
            to="https://www.facebook.com/share/1AVgZWN7uc/"
            aria-label="Facebook"
          >
            Facebook
          </Link>
        </div>
        <div className="newsletter mt-5">
          <p>Certified spam-free, enjoy</p>
          <form
            className="newsletter-form"
            id="sib-form"
            method="POST"
            action={URL_FORM_BREVO}
            data-type="subscription"
            target="_blank"
          >
            <div className="form-group">
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                name="EMAIL"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="termsCheckbox"
                name="OPT_IN"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                required
              />
              <label className="form-check-label" htmlFor="termsCheckbox">
                I agree to the <a href="/privacy-policy">terms</a> and{" "}
                <a href="/terms-of-use">Privacy Policy</a>.
              </label>
            </div>
            <button type="submit" className="btn-primary">
              Subscribe
            </button>
          </form>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} weeklycyber All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
